import { useRef, useCallback, useState } from "react";
import PostWritingPopup from "./PostWritingPopup.component";
import { uploadImage } from "api/common/Data.api";
import * as CommunityApi from "api/student/Community.api";

const PostWritingPopupContainer = (props: any) => {
    const {
        onClose,
        addPost,
        initSubject
    } = props;

    // 포스트 관련
    const [isPosting, setIsPosting] = useState(false);
    const [images, setImages] = useState<Array<{ id: string; url: string, file?: File }>>([]);
    const [content, setContent] = useState("");
    const [subject, setSubject] = useState(initSubject || "");
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [hasMore, setHasMore] = useState(true);

    // 이미지 업로드 처리
    const handleImageUpload = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;

        if (images.length + files.length > 10) {
            alert("이미지는 최대 10개까지만 업로드 가능합니다.");
            return;
        }

        // 이미지 파일들을 순서대로 처리하기 위해 Promise 배열 생성
        const imagePromises = Array.from(files).map(file => {
            return new Promise<{ id: string, url: string, file: File }>((resolve) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    if (e.target?.result) {
                        resolve({
                            id: Math.random().toString(36).substr(2, 9),
                            url: e.target.result as string,
                            file: file
                        });
                    }
                };
                reader.readAsDataURL(file);
            });
        });

        // 모든 이미지가 로드되면 순서대로 상태에 추가
        Promise.all(imagePromises).then(newImages => {
            setImages(prev => [...prev, ...newImages]);
        });

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }, [images.length]);

    const handleRemoveImage = useCallback((id: string) => {
        setImages(prev => prev.filter(image => image.id !== id));
    }, []);

    const handleContentChange = useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newContent = event.target.value;
        setContent(newContent);
    }, []);

    const handleSubjectChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        // 스페이스바 무시
        const newSubject = event.target.value.replace(/\s+/g, '');
        setSubject(newSubject);
    }, []);

    const handlePost = async (e: React.FormEvent) => {
        if (isPosting) return;
        if (!content.trim()) {
            alert("내용을 입력해주세요.");
            return;
        }

        try {
            setIsPosting(true);

            const uploadedImageIdList = [];
            for (const image of images) {
                if (image.file) {
                    const response = await uploadImage(image.file);
                    if (response?.id) {
                        uploadedImageIdList.push(response.id);
                    }
                }
            }

            const result = await CommunityApi.createPost(subject.trim(), content.trim(), uploadedImageIdList) as any
            if (result?.data?.data?.info) {
                setContent("");
                setImages([]);
                const info = result?.data?.data?.info;
                addPost(info);
                onClose();
            }
            // fetchPosts();
        } catch (error) {
            console.error('Failed to post:', error);
            alert("Error to post");
        } finally {
            setIsPosting(false);
        }
    };

    return (
        <PostWritingPopup
            onClose={onClose}
            content={content}
            initSubject={initSubject}
            subject={subject}
            images={images}
            onContentChange={handleContentChange}
            onSubjectChange={handleSubjectChange}
            onRemoveImage={handleRemoveImage}
            onImageUpload={handleImageUpload}
            onPost={handlePost}
            isPosting={isPosting}
            fileInputRef={fileInputRef}
        />
    );
};

export default PostWritingPopupContainer;